import { actionLogUsers } from './actionLogUsers'
import { downloadActionLogs } from './downloadActionLogs'
import { fetchActionLogs } from './fetchActionLogs'
import { fetchActions } from './fetchActions'

export const actionLogs = {
  index(
    agencyCode: string,
    startDate: Date,
    endDate: Date,
    userId?: number,
    route?: string,
    page?: number
  ) {
    return fetchActionLogs(agencyCode, startDate, endDate, userId, route, page)
  },
  actionLogUsers() {
    return actionLogUsers()
  },
  actions() {
    return fetchActions()
  },
  download(
    agencyCode: string,
    startDate: Date,
    endDate: Date,
    userId?: number,
    route?: string
  ) {
    return downloadActionLogs(agencyCode, startDate, endDate, userId, route)
  },
}
